import qs from 'qs';
import isNil from 'lodash/isNil';

const defaultQsConfig = { arrayFormat: 'repeat', encode: true };
export const getQueryParams = (params, config = defaultQsConfig) => {
  if (isNil(params) || Object.keys(params)?.length === 0) {
    return '';
  }
  const stringified = qs.stringify(params, config);
  return stringified.length > 0 ? `?${stringified}` : '';
};

export const makeRequest = (request) => request
  .then(({ data }) => data)
  .catch((error) => {
    console.log(error);
    throw error;
  });

// Utils to work with multiple useQuery of react-query

export const getQueriesLoadingState = (queries) => ({
  isLoading: queries.some(({ isLoading }) => isLoading),
  isError: queries.some(({ isError }) => isError),
  error: queries.find(({ error }) => error)?.error,
});
